import { CATEGORIES } from "@/constants/categories";

// Kategorie-Icon Komponente
const CategoryIcon = ({ category, size = 16, active = true }) => {
  const config = CATEGORIES[category] || CATEGORIES.herz;
  const Icon = config.icon;
  return (
    <Icon 
      size={size} 
      style={{ 
        color: active ? config.color : 'rgba(255,255,255,0.3)',
        transition: 'color 0.3s ease'
      }} 
    />
  );
};

export default CategoryIcon;
